export default "__VITE_ASSET__D54H7ssH__"